import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

export const deleteInstallmentPlanOperation = async (
  user: UserSummaryType,
  installmentPlanId: number,
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);
    const res = await appApi.deleteInstallmentPlan(installmentPlanId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    toast.success('הוראת הקבע נמחקה בהצלחה');
    //toast.warn(`${JSON.stringify(user)}`);
    const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    onSuccess?.();
    setLoading(false);
    return true;
  } catch (e) {
    console.error('Error deleting installment plan:', e);
    toast.error('שגיאה במחיקת הוראת הקבע');
    setLoading(false);
    return false;
  }
};
